import { render, staticRenderFns } from "./frequently_asked_questions.vue?vue&type=template&id=a2035be2"
import script from "./frequently_asked_questions.vue?vue&type=script&lang=js"
export * from "./frequently_asked_questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports